module.exports = __webpack_public_path__ + "static/media/fvs_valve1_19.9bf21268.jpg";